import React, { useState, useEffect, useContext } from "react";
import axios from 'axios';
import qs from 'qs';
import { useFetch } from 'use-http';
import { Product } from './Product';
import {
  useParams,
  useLocation,
  useHistory,
  Link as RouterLink
} from "react-router-dom";
import Alert from '@material-ui/core/Alert'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Slide, Button, CircularProgress, Grid, Input, Stack, Link } from "@material-ui/core";
import { makeStyles } from '@material-ui/styles';
import { AuthContext } from '../components/AuthContext';

const useStyles = makeStyles(theme => ({
  successAlert: {
    width: '50%',
    margin: '0 auto',
    padding: 20,
    marginBottom: 30,
    textAlign: 'center',
    justifyContent: 'space-around'
  },
  root: {
    backgroundColor: '#fefff8',
    padding: 50,
    width: '100%',
    height: '100%',
    backgroundImage: 'linear-gradient(135deg, #5458ab 25%, transparent 25%), linear-gradient(225deg, #5458ab 25%, transparent 25%), linear-gradient(45deg, #5458ab 25%, transparent 25%), linear-gradient(315deg, #5458ab 25%, #fefff8 25%)',
    backgroundPosition: '4px 0, 4px 0, 0 0, 0 0',
    backgroundSize: '8px 8px',
    backgroundRepeat: 'repeat'
  },
  statusBar: {
    padding: 10,
    backgroundColor: theme.palette.primary.main,
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    color: 'white'
  }
}));
const BASE_URL = `${process.env.REACT_APP_API_URL}/v1`;

export function ProductView({ onSave, onPurchase }) {
  const { productId } = useParams();
  const { address, token } = useContext(AuthContext);
  const [hide, setHide] = useState(false);
  const[purchase, setPurchase] = useState();
  const location = useLocation();
  const classes = useStyles();
  const history = useHistory();

  const isNewborn = qs.parse(location.search, { ignoreQueryPrefix: true })?.newborn;

  const { loading, error, data } = useFetch(`/products/${productId}`, {}, []);

  useEffect(() => {
    let timeout = null;
    const exec = async () => {
      if (!token) {
        return;
      }

      const fetchPurchases = async () => await axios.get(
        `${BASE_URL}/products/${productId}/purchases`,
        {
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );

      const purchases = await fetchPurchases();

      if (!purchases.data) {
        return null;
      } else {
        const latest = purchases.data.sort((a, b) => a.createdAt < b.createdAt)[0] || {};
        setPurchase(latest);

        if (latest.status === 'pending') {
          timeout = setTimeout(() => exec().then(status => {
            if (status === 'verified') {
              window.location.reload();
            }
          }), 8000)
        }

        return latest.status;
      }
    }

    exec();

    return () => clearTimeout(timeout);
  }, [productId, token])

  const { get: downloadUrl } = useFetch(`/products/${productId}/download`);
  const [copied, setCopied] = useState(false);
  const url = window.location.protocol + '//' + window.location.host + '/products/' + data?.id

  const onCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 500);
  };

  const download = async () => {
    const { url } = await downloadUrl();
    let tag = document.createElement('a');
    tag.href = url;
    tag.setAttribute('download', '');
    document.body.appendChild(tag);
    tag.click();
    console.log(tag)
    document.body.removeChild(tag);
  }

  const isOwn = data?.userId === address;

  if (error) {
    return <Alert variant="outlined" severity="error">Something went wrong. Try refreshing.</Alert>
  }

  if (loading) {
    return <CircularProgress style={{ position: 'absolute', top: '48%', left: '48%' }} />;
  }

  return (
    <div className={classes.root}>
      {data && (
        <Product
          product={data}
          purchase={purchase}
          onPurchase={onPurchase}
          onDownload={download}
        />
      )}

      {isOwn && !hide && (
        <Slide in={true} direction="up" mountOnEnter unmountOnExit>
          <div className={classes.statusBar}>
            <Grid
              container
              style={{ padding: 30, height: '100%' }}
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item xs={12} md={6}>
                {isNewborn && <h2 style={{ margin: 0, padding: 0, marginBottom: 10 }}>Success! Here's what your listing looks like.</h2>}
                {!isNewborn && <h2 style={{ margin: 0, padding: 0, marginBottom: 10 }}>This is a preview of your listing</h2>}
              </Grid>
              <Grid item xs={12} md={6} style={{ textAlign: 'right' }}>
                <Stack direction="row" spacing={3}>

                  <Grid container justifyContent="flex-end" spacing={3}>
                    {isNewborn && (<Grid item xs>
                      <Input style={{ backgroundColor: 'lightblue', padding: '10px 20px' }} fullWidth value={url} />
                    </Grid>)}
                    <Grid item width="50">
                      <CopyToClipboard hidden onCopy={onCopy} text={url}>
                        <Button style={{ height: '100%' }} color="secondary" variant="contained">{copied ? 'Copied!' : 'Copy URL'}</Button>
                      </CopyToClipboard>

                    </Grid>
                  </Grid>
                  <Button variant="contained" color="secondary" component={RouterLink} to={`/products/${data.id}/edit`}>Edit</Button>
                  <Button color="secondary" onClick={() => setHide(true)}>Hide</Button>
                </Stack>
              </Grid>
            </Grid>
          </div>
        </Slide>
      )}
    </div>
  );
}
